import { IconClockX } from "@tabler/icons-react";
import { useState } from "react";

function Statistics({ data, isSuccess, showExpired }) {
  return (
    <div className="w-100 p-4 m-2 shadow-xl rounded-lg bg-slate-200">
      {isSuccess && <Table stats={data} showExpired={showExpired} />}
    </div>
  );
}
function Table({ stats, showExpired }) {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Code
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Order Count
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Drink Count
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {stats
                    .filter((x) =>
                      showExpired ? true : new Date(x.max) > new Date()
                    )
                    .map((stat, idx) => (
                      <tr key={`stat-row-${idx}`} className="even:bg-gray-50">
                        <td className="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {stat.discount_identifier}
                          {new Date(stat.max) < new Date() && (
                            <IconClockX
                              title="This code has expired"
                              className="text-red-600 w-5 h-5 inline ms-2"
                            />
                          )}
                        </td>
                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                          {stat.order_count}
                        </td>
                        <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                          {stat.drink_count}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Statistics;
